import { z } from 'zod';
import {
  CompanyReturnSchema,
  AllCompaniesReturnSchema,
  CompanyProvisionBodySchema,
  CompanyProvisionResponseSchema,
} from './company.schema';
import { COMPANY_PATH_NAME } from './company.constants';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';

export const CompanyContract = terraContract
  .prefix(`/${COMPANY_PATH_NAME}`)
  .router({
    getCompany: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'Get Company Profile by tenant id',
        inputStructure: 'detailed',
      })
      .output(CompanyReturnSchema),
    getAllCompanies: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'GET',
        path: '/all',
        summary:
          'Get all companies accessible to the current user (based on verified Descope membership).',
        inputStructure: 'detailed',
      })
      .output(AllCompaniesReturnSchema),
    getCompanyByName: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'GET',
        path: '/{companyName}',
        summary: 'Get Company Profile',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: z.object({ companyName: z.string() }) }))
      .output(CompanyReturnSchema),
    getCompanyByDomainName: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'GET',
        path: '/domain/{domainName}',
        summary: 'Get Company Profile by domain name',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: z.object({ domainName: z.string() }) }))
      .output(CompanyReturnSchema),
    provisionCompany: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/provision',
        summary: 'Trigger async company provisioning for a tenant (terra-only)',
        inputStructure: 'detailed',
        successStatus: 202,
      })
      .input(z.object({ body: CompanyProvisionBodySchema }))
      .output(CompanyProvisionResponseSchema),
  });
